import { Util } from '@/modules/util'
import type {
  ContractRevision,
  FamilyUserLicense,
  ProcessingFeeConfig,
  MenuItemsSnapshotGroupedByElement
} from '@/types/contract'
import { Request } from '@/classes/Request.ts'
import type { PaymentSchedule } from '@/types/contract.ts'

interface PaymentScheduleEstimateResponse {
  paymentSchedule: PaymentSchedule[]
  license: FamilyUserLicense
  creditFeeConfig: ProcessingFeeConfig
  bankFeeConfig: ProcessingFeeConfig
  menuItemsSnapshotGroupedBy: MenuItemsSnapshotGroupedByElement[]
}

export const paymentScheduleEstimate = async (
  paymentPlanId: number | null,
  paymentDay: number | null,
  contractRevisionId: number,
  depositAmount: number | null,
  intervalBillingScheduleId: number | null
) => {
  type Obj = Record<string, unknown>
  const params: Obj = {
    contract_revision_id: contractRevisionId
  }

  if (depositAmount !== null) {
    params.deposit_amount = depositAmount
  }

  if (paymentPlanId !== null) {
    params.payment_plan_id = paymentPlanId
  }

  if (paymentDay !== null) {
    params.payment_day = paymentDay
  }

  if (intervalBillingScheduleId !== null) {
    params.interval_billing_schedule_id = intervalBillingScheduleId
  }

  const response = await new Request().get('/ajax/payment_schedule_estimate', params)
  return {
    paymentSchedule: Util.Obj.keysToCamel(response.data.payment_schedule) as PaymentSchedule[],
    license: Util.Obj.keysToCamel(response.data.license) as FamilyUserLicense,
    creditFeeConfig: Util.Obj.keysToCamel(response.data.credit_fee_config) as ProcessingFeeConfig,
    bankFeeConfig: Util.Obj.keysToCamel(response.data.bank_fee_config) as ProcessingFeeConfig,
    menuItemsSnapshotGroupedBy: Util.Obj.keysToCamel(
      response.data.menu_items_snapshot_grouped_by
    ) as MenuItemsSnapshotGroupedByElement[]
  } as PaymentScheduleEstimateResponse
}
